import i18n from '~/services/i18n';

export interface ITopNavigation {
  key?: string;
  path: string;
  text: string;
  condition?: boolean | { role: string[] };
  menuProps?: Record<string, unknown>;
}

type TopNavigationFF = {
  ENABLE_TRANSPORTER_PIPELINE: boolean;
  UPI_MIGRATION: boolean;
};

const topNavigations = ({ ENABLE_TRANSPORTER_PIPELINE, UPI_MIGRATION }: TopNavigationFF) => [
  {
    key: 'shippers',
    path: '/shippers',
    text: i18n.t('common:shippers'),
    condition: true,
  },
  {
    key: 'transporters',
    path: ENABLE_TRANSPORTER_PIPELINE ? '/transporters/pipeline' : '/transporters',
    text: i18n.t('common:transporters'),
    condition: true,
    menuProps: {
      'data-testid': 'mnuTransporters',
    },
  },
  {
    key: 'shipments',
    path: '/shipments',
    text: i18n.t('common:shipments'),
    condition: true,
  },
  {
    key: 'payables',
    path: '/payables',
    text: i18n.t('common:payables'),
    condition: true,
    menuProps: {
      'data-testid': 'mnuTptPayables',
    },
  },
  ...(
    UPI_MIGRATION
      ? []
      : [
        {
          key: 'receivables',
          path: '/receivables',
          text: i18n.t('common:receivables'),
          condition: true,
        },
      ]),

];

export default topNavigations;
